import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgFileText = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.938 7.438c.145.145.291.333.437.562H18V.625a3.3 3.3 0 0 1 .563.438l6.375 6.375zM17.5 10H26v16.5c0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 24.5 28h-21c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 2 26.5v-25c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 3.5 0H16v8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zM20 21.5v-1a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14h-11a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v1a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14h11a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36zm0-4v-1a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14h-11a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v1a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14h11a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36zm0-4v-1a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14h-11a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v1a.49.49 0 0 0 .14.36.49.49 0 0 0 .36.14h11a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36z" />
  </svg>
);
export default SvgFileText;
